"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JamoConstants = void 0;
var JamoConstants;
(function (JamoConstants) {
    /** 자음 목록 */
    JamoConstants.consonants = "ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎ".split("");
    /** 모음 목록 */
    JamoConstants.vowels = "ㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣ".split("");
    /** 초성 목록 */
    JamoConstants.initialConsonants = "ㄱㄲㄴㄷㄸㄹㅁㅂㅃㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎ".split("");
    /** 중성 목록 */
    JamoConstants.medialVowels = "ㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣ".split("");
    /** 종성 목록 */
    JamoConstants.finalConsonats = "ㄱㄲㄳㄴㄵㄶㄷㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅄㅅㅆㅇㅈㅊㅋㅌㅍㅎ".split("");
    /** 합성하기 위한 모음 매칭표 */
    JamoConstants.vowelMapForComposition = new Map([
        ["ㅗㅏ", "ㅘ"],
        ["ㅗㅐ", "ㅙ"],
        ["ㅗㅣ", "ㅚ"],
        ["ㅜㅓ", "ㅝ"],
        ["ㅜㅔ", "ㅞ"],
        ["ㅜㅣ", "ㅟ"],
        ["ㅡㅣ", "ㅢ"],
    ]);
    /** 분해하기 위한 모음 매칭표 */
    JamoConstants.vowelMapForDecomposition = new Map([
        ["ㅘ", "ㅗㅏ"],
        ["ㅙ", "ㅗㅐ"],
        ["ㅚ", "ㅗㅣ"],
        ["ㅝ", "ㅜㅓ"],
        ["ㅞ", "ㅜㅔ"],
        ["ㅟ", "ㅜㅣ"],
        ["ㅢ", "ㅡㅣ"],
    ]);
    /** 합성하기 위한 종성 매칭표 */
    JamoConstants.finalConsonatMapForComposition = new Map([
        ["ㄱㅅ", "ㄳ"],
        ["ㄴㅈ", "ㄵ"],
        ["ㄴㅎ", "ㄶ"],
        ["ㄹㄱ", "ㄺ"],
        ["ㄹㅁ", "ㄻ"],
        ["ㄹㅂ", "ㄼ"],
        ["ㄹㅅ", "ㄽ"],
        ["ㄹㅌ", "ㄾ"],
        ["ㄹㅍ", "ㄿ"],
        ["ㄹㅎ", "ㅀ"],
        ["ㅂㅅ", "ㅄ"],
    ]);
    /** 분해하기 위한 종성 매칭표 */
    JamoConstants.finalConsonatMapForDecomposition = new Map([
        ["ㄳ", "ㄱㅅ"],
        ["ㄵ", "ㄴㅈ"],
        ["ㄶ", "ㄴㅎ"],
        ["ㄺ", "ㄹㄱ"],
        ["ㄻ", "ㄹㅁ"],
        ["ㄼ", "ㄹㅂ"],
        ["ㄽ", "ㄹㅅ"],
        ["ㄾ", "ㄹㅌ"],
        ["ㄿ", "ㄹㅍ"],
        ["ㅀ", "ㄹㅎ"],
        ["ㅄ", "ㅂㅅ"],
    ]);
})(JamoConstants = exports.JamoConstants || (exports.JamoConstants = {}));
